import { AppLayout } from "@/components/layout/app-layout";
import { PageHeader } from "@/components/layout/page-header";
import { TeamAnalyticsHeader } from "@/components/team-analytics/team-analytics-header";
import { TeamPerformanceOverview } from "@/components/team-analytics/team-performance-overview";
import { IndividualPerformance } from "@/components/team-analytics/individual-performance";
import { ProductivityTrends } from "@/components/team-analytics/productivity-trends";
import { WorkloadDistribution } from "@/components/team-analytics/workload-distribution";
import { CollaborationInsights } from "@/components/team-analytics/collaboration-insights";

const TeamManagement = () => {
  return (
    <AppLayout>
      <PageHeader
        title="Team Management"
        subtitle="Team analytics and performance insights"
      />
      <main className="flex-1 p-page-padding lg:p-page-padding-lg overflow-y-auto">
        <TeamAnalyticsHeader />
        <TeamPerformanceOverview />
        
        <section className="grid grid-cols-3 gap-section-gap">
          {/* Left Column */}
          <div className="col-span-3 xl:col-span-2 flex flex-col gap-section-gap">
            <IndividualPerformance />
            <ProductivityTrends />
          </div>

          {/* Right Column */}
          <div className="col-span-3 xl:col-span-1 flex flex-col gap-section-gap">
            <WorkloadDistribution />
            <CollaborationInsights />
          </div>
        </section>
        
        <footer className="mt-8 pt-6 border-t border-brand-border flex justify-between items-center">
          <p className="text-xs text-brand-text-primary">Copyright © 2024 Swiss Finance OS</p>
          <div className="flex items-center gap-4 text-xs text-brand-text-secondary">
            <span 
              className="hover:text-brand-primary cursor-pointer"
              onClick={() => window.open('/privacy', '_blank')}
            >
              Privacy Policy
            </span>
            <span 
              className="hover:text-brand-primary cursor-pointer"
              onClick={() => window.open('/terms', '_blank')}
            >
              Terms & Conditions
            </span>
            <span 
              className="hover:text-brand-primary cursor-pointer"
              onClick={() => window.open('mailto:support@swissfinanceos.com')}
            >
              Contact
            </span>
          </div>
        </footer>
      </main>
    </AppLayout>
  );
};

export default TeamManagement;